export default function (str) {
  return JSON.stringify(str).slice(1, -1);
}
